/** ***
------------------------------------------------------------------------
ANOMALY DETECTIONS LIST PAGE
------------------------------------------------------------------------
"description": null,
"anomalyType": "NEW_EXTERNAL_CONN_FROM_HOST_PROGRAM",
"agentId": "23",
"user": "",
"program": "/usr/bin/wget",
"ip": "",
"city": "",
"country": "",
"file": "",
"metadata": null,
"trailId": null,
"eventTime": 1622058224119078000,
"uid": "",
"score": 0

** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const anomaliesMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'expand',
        description: 'More Details',
        label: 'More Details',
        sortable: false,
        'min-width': 150,
        name: 'expand',
        component: 'ExpandAnomalyDetails'
      },
      {
        datatype: 'string',
        description: 'Instance',
        label: 'Instance',
        name: 'description',
        'min-width': 250,
        sortable: true
      },
      {
        datatype: 'string',
        description: 'Type',
        label: 'Type',
        name: 'anomalyCategory',
        'min-width': 100,
        sortable: true,
        display: 'iconAndText',
        displayKey: [
          {
            key: 'LOGIN_ANOMALY',
            display: 'Login'
          },
          {
            key: 'PROCESS_ANOMALY',
            display: 'Process'
          }
        ]
      },
      {
        datatype: 'objectpath',
        description: 'Entity',
        label: 'Entity',
        sortable: false,
        'min-width': 200,
        name: 'entities',
        display: 'component',
        component: 'InstanceEntityTableCell',
        componentFields: {
          entities: 'entities'
        }
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Time',
        label: 'Time',
        name: 'eventTime',
        'min-width': 150,
        sortable: true
      },
      {
        datatype: 'objectpath',
        description: 'Actions',
        label: ' ',
        sortable: false,
        'min-width': 70,
        name: 'state',
        display: 'component',
        component: 'AnomalyDismissTableCell',
        componentFields: {
          entities: 'entities',
          state: 'state',
          uid: 'uid'
        }
      },
      {
        datatype: 'objectpath',
        description: 'Description',
        label: 'Description',
        name: 'anomalyMetadata.drillDownResult.description',
        'min-width': 250,
        sortable: true,
        visible: false
      },
      {
        datatype: 'objectpath',
        description: 'Potential Impact',
        label: 'Potential Impact',
        name: 'anomalyMetadata.drillDownResult.potentialImpact',
        'min-width': 250,
        sortable: true,
        visible: false
      },
      {
        datatype: 'objectpath',
        description: 'recommendation',
        label: 'Recommendation',
        name: 'anomalyMetadata.drillDownResult.recommendation',
        'min-width': 250,
        sortable: true,
        visible: false
      }
    ]
  }
}

export { anomaliesMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/anomalies/anomalies-meta.js